import { render, staticRenderFns } from "./TabFocus.vue?vue&type=template&id=630c6817&"
import script from "./TabFocus.vue?vue&type=script&lang=js&"
export * from "./TabFocus.vue?vue&type=script&lang=js&"
import style0 from "./TabFocus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630c6817')) {
      api.createRecord('630c6817', component.options)
    } else {
      api.reload('630c6817', component.options)
    }
    module.hot.accept("./TabFocus.vue?vue&type=template&id=630c6817&", function () {
      api.rerender('630c6817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabFocus.vue"
export default component.exports